import { useEffect, useState } from 'react';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import axios from '../../../lib/axios';
import { CATEGORIES_CREATE, DIVISION_CREATE } from '../../../lib/endpoints/category';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';

// ------------------------------------------------------------------------------------------------

interface Props {
  dataMasterCategory: SuppliesCategoryProduct[];
  merchantId: string;
  divisionId: string;
  onRefetchData: any;
  onClose: VoidFunction;
}

const useFormCategoryController = ({
  dataMasterCategory,
  merchantId,
  divisionId,
  onRefetchData,
  onClose,
}: Props) => {
  // variables
  const [categoryValue, setCategoryValue] = useState<string>(null!);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] = useState<boolean>(false);

  // functions
  const handleCategoryChange = (e: any) => {
    setCategoryValue(e.target.value);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleOpenConfirmDialog = () => {
    if(handleValidateForm()){
      setOpenConfirmDialog(true);
    }
  
  };

  const handleValidateForm = () => {
    if (!categoryValue) {
      setErrorMessage('Please select division first');

      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleClickConfirmButton = () => {
    handleCreateData();
  };

  const handleCreateData = async () => {
    try {
      setLoadingConfirmDialog(true);
      const input = {
        supplies_product_category_id: categoryValue,
        division_name_id: divisionId,
        merchant_id: merchantId,
      };
      await axios.post(CATEGORIES_CREATE, input);
      await onRefetchData();
      onClose();
    } catch (err: any) {
      try {
        const getErrorMessage: string = err.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err2) {
        setErrorMessage('Server error please try again');
      }
    } finally {
      setLoadingConfirmDialog(false);
      setOpenConfirmDialog(false);
    }
  };

  // useEffect
  useEffect(() => {
    if (dataMasterCategory?.length > 0) {
      setCategoryValue(dataMasterCategory[0]?.id);
    }
  }, [dataMasterCategory]);
  // return

  return {
    categoryValue,
    handleCategoryChange,
    errorMessage,
    openConfirmDialog,
    loadingConfirmDialog,
    handleCloseConfirmDialog,
    handleClickConfirmButton,
    handleOpenConfirmDialog,
    handleSetErrorMessage: (newValue: string) => setErrorMessage(newValue),
  };
};
export default useFormCategoryController;
